import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { sharedColors, sharedStyles } from '../../utils/Style';
import { pageCategories } from '../../variables/PageCategory';
import { NavBarCategory } from './NavBarCategory';
import { removeToken } from '../../utils/Auth';

export const NavBar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate('/login');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRightStyle: 'groove',
        borderRightColor: '#171d2d',
        backgroundColor: '#272f3e',
        borderRightWidth: '1px',
        height: '100vh',
        width: 240,
        flexShrink: 0,
      }}
    >
      <Typography variant='h6' sx={{ mx: 1, my: 2, color: sharedColors.white }}>
        NNET E-Ticaret
      </Typography>
      <Divider />
      <Box
        sx={{
          overflowY: 'auto',

          scrollbarWidth: 'thin',
          scrollbarColor: '#4a5568 transparent',

          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#4a5568',
            borderRadius: '6px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#6b7280',
          },
        }}
      >
        {pageCategories.map((category) => (
          <NavBarCategory key={category.name} category={category} />
        ))}
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Button
        onClick={handleLogout}
        sx={{ ...sharedStyles.buttonText, color: sharedColors.white }}
      >
        Çıkış Yap
      </Button>
    </Box>
  );
};
